import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService } from '../../shared/services/localStorage/local-storage.service';
import { SessionService } from '../../shared/services/session/session.service';
import { AuthService } from '../../shared/msalConfig/auth-service.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  token: string = '';

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private sessionService: SessionService,
    private authService: AuthService,
  ) {}

  canActivate() {
    this.token = this.localStorageService.get('bearerToken');
    const authType = this.localStorageService.get('AuthType');

    if (!authType) {
      this.router.navigate(['/login']);
      return false;
    }

    if (authType === 'AD' && this.token !== '') {
      return true;
    }

    if (
      (authType === 'Portal' || authType === 'IntegWeb') &&
      this.token !== ''
    ) {
      if (this.sessionService.isTokenExpired(this.token)) {
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
